import { render } from "./bundle-customiser.vue?vue&type=template&id=9e54e2b2"
import script from "./bundle-customiser.vue?vue&type=script&lang=js"
export * from "./bundle-customiser.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__